import React from 'react';
import WaveIcon from '../../../../../icons/Wave';
import ArrowUpIcon from '../../../../../icons/Arrow/Up';
import ArrowIcon from '../../../../../icons/ArrowB';
import WarnBIcon from '../../../../../icons/Warn/B';

function CircleA(props) {
  return (
    <div
      {...props}
      className={`sq(|min)48 layoutRow fhaC fvaC r ov `
        + (props.className || '')}
    />
  );
}

export const DEFAULT_ICON = (
  <CircleA className="bgFFBF43">
    <WaveIcon className="w20 cF rlv st-2 sr-2"/>
  </CircleA>
);
export const COMPLETED_ICON = (
  <CircleA className="bg2CE889">
    <ArrowIcon className="w18 cF"/>
  </CircleA>
);

export const ICONS_MAP = {
  initiated: (
    <CircleA className="bg5B47FF">
      <ArrowUpIcon className="w17 cF"/>
    </CircleA>
  ),
  pending: DEFAULT_ICON,
  completed: COMPLETED_ICON,
  paid: COMPLETED_ICON,
  canceled: (
    <CircleA className="bgF bs b1 bc8">
      <div className="w24 h4 bg8 r2"/>
    </CircleA>
  ),
  failed: (
    <CircleA className="bgEE4F4F">
      <WarnBIcon className="w4 cF"/>
    </CircleA>
  ),
};
